/* Underdog Coffee — header behaviour
   Mobile nav toggle + keeping the cart counter in sync with Dawn's cart events. */
(function () {
  function initNav() {
    document.querySelectorAll('[data-ud-nav-toggle]').forEach(function (toggle) {
      if (toggle.dataset.udBound) return;
      toggle.dataset.udBound = 'true';

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
      });
    });

    // Close the menu after following an in-page link.
    document.querySelectorAll('[data-ud-nav] a').forEach(function (link) {
      if (link.dataset.udBound) return;
      link.dataset.udBound = 'true';

      link.addEventListener('click', function () {
        var nav = link.closest('[data-ud-nav]');
        var toggle = nav && nav.parentElement.querySelector('[data-ud-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function setCount(count) {
    var padded = count < 10 ? '0' + count : String(count);
    document.querySelectorAll('[data-ud-cart-count]').forEach(function (el) {
      el.textContent = padded;
    });
  }

  function initCartSync() {
    // Dawn publishes cartUpdate through its own pub/sub; fall back to refetching.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cart = event && event.cartData;
        if (cart && typeof cart.item_count === 'number') {
          setCount(cart.item_count);
        } else {
          fetch(window.routes.cart_url + '.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (c) {
              setCount(c.item_count);
            })
            .catch(function () {});
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initCartSync();
  });

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', initNav);
})();
